import { render, staticRenderFns } from "./ReportAddModal.vue?vue&type=template&id=a510c8b6&scoped=true"
import script from "./ReportAddModal.vue?vue&type=script&lang=js"
export * from "./ReportAddModal.vue?vue&type=script&lang=js"
import style0 from "./ReportAddModal.vue?vue&type=style&index=0&id=a510c8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a510c8b6",
  null
  
)

export default component.exports